import { execAdmin } from '@src/apis/reware/utils';

import type {
  ShopifyProductRedirectGroup,
  FetchRedirectGroupExecVariables,
  FetchRedirectGroupExecResponse,
} from './types';

export interface FetchRedirectGroupArgs {
  partnerCode: string;
  id: number;
}

export const fetchRedirectGroup = async ({
  partnerCode,
  id,
}: FetchRedirectGroupArgs): Promise<ShopifyProductRedirectGroup> => {
  const query = `
    query getShopifyProductRedirectGroup(
      $partnerCode: String!
      $id: Int!
    ) {
      shopifyProductRedirectGroup(
        partnerCode: $partnerCode
        id: $id
      ) {
        currentTarget
        count
        redirects {
          id
          partnerCode
          subdomain
          shopifyProductId
          catalogItemId
          shopifyRedirectId
          fromHandle
          toHandle
          currentTarget
          status
          createdAt
          updatedAt
          catalogItem {
            id
            title
            sku
          }
        }
      }
    }
  `;

  const data = await execAdmin<FetchRedirectGroupExecVariables, FetchRedirectGroupExecResponse>(
    query,
    { variables: { partnerCode, id } },
  );

  const result = data.shopifyProductRedirectGroup;
  if (!result) {
    throw new Error(
      `fetchRedirectGroup: unexpected response — shopifyProductRedirectGroup is ${result === null ? 'null' : 'undefined'} (partnerCode=${partnerCode}, id=${id})`,
    );
  }

  return result;
};
